import React from "react";

const ToggleSwitch = ({ checked, onChange, label, labelStart, labelStartStyle, isDisabled, labelStyle }:any) => {
  return (
    <div className={`d-flex align-items-center py-2 px-1 ${isDisabled ? "disable-custom" : ""}`} style={{ overflow: "hidden" }}>
      {labelStart && <div className={`${labelStartStyle ? labelStartStyle : "me-2" }`}>{labelStart}</div>}
      <label className="toggle mb-0">
        <input
          className="toggle-checkbox"
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={isDisabled ? isDisabled : false}
        />
        <div className="toggle-switch"></div>
      </label>
      {label && <div className={`${labelStyle ? labelStyle : "ms-2"}`}>{label}</div>}
    </div>
  );
};

export default ToggleSwitch;
